/* eslint-disable react/prefer-es6-class */
import React from 'react';
import Localization from 'es6/services/localization';
import ProgressBar from 'es6/components/common/progress-bar';

export const SessionProgressBar = React.createClass({
  displayName: 'SessionProgressBar',

  propTypes: {
    progress: React.PropTypes.number.isRequired,
  },

  getInitialState() {
    return {
      animatedProgress: 0,
    };
  },

  _handleAnimationIteration(animatedProgress) {
    this.setState({ animatedProgress });
  },

  render() {
    return (
      <div className="session-progress">
        <span className="text">{Localization.t('js_iknow.session progress')}</span>
        <span className="percent">{this.state.animatedProgress}%</span>
        <ProgressBar animationDurationMillis={500} progress={this.props.progress} onAnimationIteration={this._handleAnimationIteration} />
      </div>
    );
  },
});

export default SessionProgressBar;
